import { FC, useMemo, useEffect, useState } from "react";
import { useTranslation } from "next-i18next";

import { Modal, CloseIcon2 } from "@/components/Modal";
import { ScrollView } from "@/components/UI/ScrollView";
import PointsBrewingItem from "./brewing-item";
import { useWindowHeight } from "@/hooks/useWindowHeight";

import { PointsBrewingInfo } from "@/types/points";

interface BrewingModalProps {
  items: PointsBrewingInfo[];
  scale?: number;
  onClose: () => void;
}

/**
 * 铸造信息弹窗
 */
const BrewingModal: FC<BrewingModalProps> = ({ items, scale = 1, onClose }) => {
  const { t } = useTranslation("points");
  const { windowHeight } = useWindowHeight();

  console.log("BrewingModal", { items }, "windowHeight", windowHeight);

  const modalStyle = useMemo(() => {
    return {
      backgroundColor: "transparent",
      "--tw-scale-x": scale,
      "--tw-scale-y": scale,
    };
  }, [scale]);

  return (
    <Modal
      style={modalStyle}
      closeIcon={<CloseIcon2 className="translate-y-[-4px]" />}
      onClose={onClose}
    >
      <div
        className="flex flex-col bg-white rounded-[40px] overflow-hidden"
        style={{
          maxHeight: Math.min(windowHeight / scale - 100, 798),
          minHeight: Math.min(windowHeight / scale - 100, 798),
        }}
      >
        <div className="flex items-center justify-center py-[24px] text-[24px] leading-[32px] font-bold font-DIN_Alternate">
          {t("brewing-tit").toUpperCase()}
        </div>
        <div className="flex-1 flex flex-col w-[512px] text-white border-0 border-t-[1px] border-solid border-[#000] overflow-hidden">
          <div className="pt-[24px] px-[56px]">
            <h4 className="m-0 flex items-center gap-[8px] text-[22px] leading-[32px] font-bold text-black">
              <span className="font-DIN_Alternate">
                {t("brewing-list-tit")}
              </span>
              <div className="text-center text-[12px] px-[8px] leading-[20px] text-black font-bold bg-[#f1f2f3] rounded-[25px]">
                {items.length}
              </div>
            </h4>
          </div>
          <div className="flex-1 flex flex-col pt-[8px] pl-[56px] pb-[56px] pr-[24px] overflow-hidden">
            <div className="relative flex-1 flex flex-col overflow-hidden">
              <div className="absolute bottom-[-2px] right-[10px] w-full h-[26px] bg-gradient-to-b from-[rgba(255,255,255,0)] to-white"></div>
              <ScrollView className="flex-1 overflow-auto">
                <div className="flex flex-wrap gap-[16px] pt-[16px] pb-[56px] pr-[30px]">
                  {items.map((info, idx: number) => (
                    <PointsBrewingItem className="" key={idx} info={info} />
                  ))}
                </div>
              </ScrollView>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BrewingModal;
